var map = {
	"./banner-font.png": "1896",
	"./bg-banner.png": "adff",
	"./guarantee-img.png": "84ae",
	"./question-icon-1.png": "92c7",
	"./question-icon-2.png": "fd34",
	"./question-icon-3.png": "5fe4",
	"./question-icon-4.png": "f44a",
	"./scene1-img.png": "6e28",
	"./scene2-img.png": "2e01",
	"./solution-icon-1.png": "f21d",
	"./solution-icon-2.png": "0949",
	"./solution-icon-3.png": "f868",
	"./solution-icon-4.png": "2dae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05a9";